'use strict'

export const ANIMATION = {}
